/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationTrackItDataTypeFilterDtoDataType } from './EnumerationTrackItDataTypeFilterDtoDataType';
import {
    EnumerationTrackItDataTypeFilterDtoDataTypeFromJSON,
    EnumerationTrackItDataTypeFilterDtoDataTypeFromJSONTyped,
    EnumerationTrackItDataTypeFilterDtoDataTypeToJSON,
} from './EnumerationTrackItDataTypeFilterDtoDataType';

/**
 * 
 * @export
 * @interface EnumerationTrackItDataTypeFilterDto
 */
export interface EnumerationTrackItDataTypeFilterDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationTrackItDataTypeFilterDto
     */
    id: string;
    /**
     * 
     * @type {EnumerationTrackItDataTypeFilterDtoDataType}
     * @memberof EnumerationTrackItDataTypeFilterDto
     */
    dataType?: EnumerationTrackItDataTypeFilterDtoDataType | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationTrackItDataTypeFilterDto
     */
    enumerationOptionTrue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationTrackItDataTypeFilterDto
     */
    enumerationOptionFalse?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationTrackItDataTypeFilterDto
     */
    enumerationOptionWarning?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationTrackItDataTypeFilterDto
     */
    $type?: EnumerationTrackItDataTypeFilterDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationTrackItDataTypeFilterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoEnumerationTrackItDataTypeFilterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.EnumerationTrackItDataTypeFilterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationTrackItDataTypeFilterDtoTypeEnum = typeof EnumerationTrackItDataTypeFilterDtoTypeEnum[keyof typeof EnumerationTrackItDataTypeFilterDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationTrackItDataTypeFilterDto interface.
 */
export function instanceOfEnumerationTrackItDataTypeFilterDto(value?: unknown): value is EnumerationTrackItDataTypeFilterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationTrackItDataTypeFilterDtoTypeEnum)[0];
}

export function EnumerationTrackItDataTypeFilterDtoFromJSON(json: any): EnumerationTrackItDataTypeFilterDto {
    return EnumerationTrackItDataTypeFilterDtoFromJSONTyped(json, false);
}

export function EnumerationTrackItDataTypeFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationTrackItDataTypeFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataType': json['dataType'] == null ? undefined : EnumerationTrackItDataTypeFilterDtoDataTypeFromJSON(json['dataType']),
        'enumerationOptionTrue': json['enumerationOptionTrue'] == null ? undefined : json['enumerationOptionTrue'],
        'enumerationOptionFalse': json['enumerationOptionFalse'] == null ? undefined : json['enumerationOptionFalse'],
        'enumerationOptionWarning': json['enumerationOptionWarning'] == null ? undefined : json['enumerationOptionWarning'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationTrackItDataTypeFilterDtoToJSON(value?: EnumerationTrackItDataTypeFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataType': EnumerationTrackItDataTypeFilterDtoDataTypeToJSON(value['dataType']),
        'enumerationOptionTrue': value['enumerationOptionTrue'],
        'enumerationOptionFalse': value['enumerationOptionFalse'],
        'enumerationOptionWarning': value['enumerationOptionWarning'],
        '$type': value['$type'],
    });
}

